import { render, staticRenderFns } from "./SideMenuButton.vue?vue&type=template&id=1008bfcb&scoped=true&"
import script from "./SideMenuButton.vue?vue&type=script&lang=js&"
export * from "./SideMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuButton.vue?vue&type=style&index=0&id=1008bfcb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1008bfcb",
  null
  
)

export default component.exports